import { useQuery } from "@apollo/client";
import _ from "lodash";
import { useReduxState } from "SubjectStandardsV2/hooks/useReduxState";
import { getCourseStandardSetsQuery } from "../modules/Queries";
import { useMemo } from "react";
import { getCurriculumIdAndType } from "SubjectStandardsV2/modules/reduxSelectors";
import { getDatasetsOrderByArgs } from "Datasets/modules/Utils";

const useCourseSets = params => {
  // Get subject ids of unit plan from params
  const { learningCourseId, subjectIds, skip } = params || {};

  const { isPYPCurriculum } = useReduxState(getCurriculumIdAndType);
  const { orderByDirection } = getDatasetsOrderByArgs();

  const { data, loading } = useQuery(getCourseStandardSetsQuery, {
    variables: {
      id: learningCourseId,
      isPYPCurriculum,
      subjects: subjectIds,
      orderByDirection,
    },
    fetchPolicy: "cache-and-network",
    context: {
      useHttpLink: true,
    },
    skip: !learningCourseId || skip,
  });

  const standardEdges = useMemo(() => {
    const standardWrapperEdges = data?.node?.standardsWrapper?.standardsEdge;
    const benchmarksWrapperEdges = data?.node?.benchmarksWrapper?.standardsEdge;

    return isPYPCurriculum ? benchmarksWrapperEdges : standardWrapperEdges;
  }, [data, isPYPCurriculum]);

  const idsToPropertiesMap = useMemo(() => {
    return _.reduce(
      standardEdges,
      (acc, edge) => {
        const { standardSet = {}, standards = [] } = edge || {};

        acc[standardSet.id] = {
          ...standardSet,
          totalCount: _.size(standards),
          standards: _.map(standards, "id"),
        };
        return acc;
      },
      {}
    );
  }, [standardEdges]);

  return {
    showLoader: _.isEmpty(data) && loading,
    idsToPropertiesMap,
    standardEdges,
  };
};

export default useCourseSets;
